import apiCore from "../../utils/api-core";

export function searchNumbers(query) {
  let url = "/api/v1/nexmo/search-numbers";

  if (query) {
    url = `${url}?${query}`;
  }

  return apiCore.get(url);
}

export function swap10DLCForTFN(userId) {
  let url = "/api/v1/nexmo/swap-10dlc-tfn";
  return apiCore.post(url, userId);
}

export function getVonageNumbersList() {
  return apiCore.get(`/api/v1/numbers/vonage/list`);
}

export function createVonageNumberStatusRecord(body) {
  return apiCore.post("/api/v1/numbers/vonage/status", body);
}

export function purchaseTFNsFromVonage(body) {
  return apiCore.post("/api/v1/numbers/vonage/tfn/buy", body);
}

export function getVonageNumbersAvailableList() {
  return apiCore.get(`/api/v1/numbers/vonage/list/available`);
}

export function getVonageNumbersListV3(params) {
  return apiCore.get("/api/v3/numbers/vonage", { params });
}

export function createVonageNumberStatusRecordV3(body) {
  return apiCore.post("/api/v3/numbers/vonage/status", body);
}

export function purchaseTFNsFromVonageV3(body) {
  return apiCore.post("/api/v3/numbers/vonage/tfn/buy", body);
}

export function exportVonageNumbersV3(params) {
  return apiCore.get("/api/v3/numbers/vonage/export", { params });
}

export function getVonageNumberHistoryV3(id) {
  return apiCore.get(`/api/v3/numbers/vonage/${id}/history`);
}
